/**
 * T7a — os testes vistos PELO PRÓPRIO funcionário ("Meus testes" e, para um admin, a própria ficha): só os
 * resultados concluídos e válidos, com "Ver resultado" e "Baixar PDF". Nada além disso — a API nem devolve o resto.
 */
import { useState } from 'react';
import { Button } from '@/components/ui';
import { VerResultadoDialog } from '@/components/testes/DialogosDoTeste';
import { formatDate } from '@/lib/format-date';
import { baixarPdfResultado } from '@/lib/testes/testes-store';
import { nomeDoTeste, preencher, TEXTOS } from '@/lib/testes/textos';
import type { ResultadoDoFuncionario, TesteNaFichaFuncionario } from '@/lib/testes/tipos';

const F = TEXTOS.ficha;

function Linha({ r, aoVer }: { r: ResultadoDoFuncionario; aoVer: () => void }) {
  return (
    <div className="flex flex-col gap-2 py-3 sm:flex-row sm:items-center sm:justify-between" data-testid={`meu-resultado-${r.id}`}>
      <div className="min-w-0">
        <p className="text-sm font-medium text-ink-1 dark:text-ink-dark-1">{r.resumo}</p>
        <p className="text-xs text-ink-3">{preencher(F.status_concluido, { data: formatDate(r.concluidoEmIso) })}</p>
      </div>
      <div className="flex shrink-0 flex-wrap gap-2">
        <Button variant="secondary" size="sm" className="min-h-[44px]" onClick={aoVer}>
          {F.botao_ver_resultado}
        </Button>
        <Button variant="ghost" size="sm" className="min-h-[44px]" onClick={() => void baixarPdfResultado(r.id, { comoFuncionario: true })}>
          {F.botao_pdf}
        </Button>
      </div>
    </div>
  );
}

export function TestesDoFuncionario({ testes }: { testes: TesteNaFichaFuncionario[] }) {
  const [vendo, setVendo] = useState<ResultadoDoFuncionario | null>(null);
  const comAlgum = testes.filter((t) => t.principal);
  if (comAlgum.length === 0) {
    return <p className="text-sm text-ink-2 dark:text-ink-dark-2" data-testid="meus-testes-vazio">{TEXTOS.meu_perfil.meus_testes_vazio}</p>;
  }
  return (
    <div className="space-y-4">
      {comAlgum.map((t) => (
        <div key={t.tipo}>
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-ink-3">{nomeDoTeste(t.tipo).teste}</p>
          <div className="divide-y divide-line dark:divide-line-dark">
            <Linha r={t.principal!} aoVer={() => setVendo(t.principal)} />
            {t.historico.map((h) => (
              <Linha key={h.id} r={h} aoVer={() => setVendo(h)} />
            ))}
          </div>
        </div>
      ))}
      {vendo && <VerResultadoDialog resultado={vendo} onClose={() => setVendo(null)} />}
    </div>
  );
}
